var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"weatherMap"}},[_c('iframe',{attrs:{"id":"map-embed-iframe","frameborder":"0","height":_vm.height,"width":"100%","src":_vm.embedURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }